var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goal-area"},[(_vm.item.shots)?_c('div',{staticClass:"goal-area-back",style:('opacity: '+_vm.item.ratio)}):_vm._e(),(_vm.item.shots)?_c('span',[_vm._v(_vm._s(_vm.item.render))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }